// Viewbar.js
import GroupByDropdown from "./features/groupByDropdown/GroupByDropdown";
import SortDropdown from "./features/groupByDropdown/SortDropdown";
import FilterDropdownTest from "./features/filterdropdown/FilterDropdownTest";

import "./Viewbar.scss";
import ToggleButton from "../../../../finalForms/ui/inputs/toggleButton/ToggleButton";
import SearchBar from "../../../../ui/searchBar/SearchBar";
import { useTaskFilter } from "../../../../../utils/Context/TaskFilterContext";
import Iconify from "../../../../../layouts/components/iconify/iconify";

const Viewbar = ({ projectId, taskFilterPageId, onToggleChange, showCompleted, allowSearch = true, onSearchChange }) => {

  const { filters, filterRequest, removeAppliedFilter, resetFilters } = useTaskFilter();

  const handleStatusToggle = () => {
    onToggleChange?.(!showCompleted)
  }

  const appliedChips = (filters || []).filter((filter) => {
    const field = filter.selectedFilterKey?.id;
    const value = filter.selectedFilterType && typeof filter.selectedFilterType === "object"
      ? filter.selectedFilterType.value
      : null;

    if (field == null || value === undefined || value === null || value === "") {
      return false;
    }

    return (filterRequest || []).some((request) =>
      request.Field === field &&
      String(request.Value) === String(value)
    );
  });

  return (
    <div className="viewbar-section-wrap">
      <div className="viewbar-section">
        <div className="left-side">
          <GroupByDropdown taskFilterPageId={taskFilterPageId} />
          <SortDropdown />
          <FilterDropdownTest projectId={projectId} taskFilterPageId={taskFilterPageId} />
        </div>

        <div className="right-side">
          <div className="search-section">
            {allowSearch && (
              <SearchBar
                handleChange={(e) => onSearchChange(e?.target?.value)}
                searchText="Search By Task Id/Title"
              />
            )}
          </div>
          <div className="checkbox-section">
            <div className="show-completed">
              <span>
                Show Completed
              </span>
              <ToggleButton
                isChecked={showCompleted}
                isdisable={false}
                onChange={handleStatusToggle}
              />
            </div>
          </div>
        </div>
      </div>

      {appliedChips.length > 0 && (
        <div className="viewbar-filter-chips">
          {appliedChips.map((filter) => {
            const fieldLabel = filter.selectedFilterKey?.label || filter.selectedFilterKey?.id;
            const operatorLabel = filter.selectedFilterCompareKey?.label || "Is";
            const valueLabel = filter.selectedFilterType?.label || filter.selectedFilterType?.value;

            return (
              <button
                type="button"
                key={filter.id}
                className="filter-chip"
                onClick={() => removeAppliedFilter(filter.id)}
              >
                <span>{fieldLabel} {operatorLabel} {valueLabel}</span>
                <Iconify icon="eva:close-fill" width={14} />
              </button>
            );
          })}
          <button type="button" className="filter-chip-clear" onClick={resetFilters}>
            Clear all
          </button>
        </div>
      )}
    </div>
  );
};

export default Viewbar;
